<template>
    <div class="help-bug-wrapper">
        <b-btn class="help-bug" variant="danger" pill :to="{name: 'help'}" title="Help centre">
            <font-awesome-icon :icon="['fas','question']" ></font-awesome-icon>
            <span class="hide"><span>&nbsp; Help centre</span></span>
        </b-btn>
    </div>
</template>